import { Box, Container, Drawer, Fade } from "@mui/material";
import React, { useState } from "react";
import DashboardNav from "./DashboardNav";
import COLORS from "../../../constants/Colors";
import { Navigate, Route, Routes } from "react-router-dom";
import {
  DashLayoutCtxProvider,
  useDashLayoutCtx,
} from "./DashLayoutCtxProvider";
import DashTracking from "./tracking/DashTracking";
import DashDrivers from "./drivers/DashDrivers";
import DashTrucks from "./trucks/DashTrucks";
import DashProfile from "./profile/DashProfile";
import DesktopOnlyView from "../../wrappers/DesktopOnlyView";
import AuthentisSmLogo from "../../../assets/images/authentis_small_icon.png";
import APP_CONSTANTS from "../../../constants/AppConstants";

const DashRoutes = () => (
  <Routes>
    <Route path="/" element={<Navigate to="trucks" />} />
    <Route path="trucks" element={<DashTrucks />} />
    <Route path="drivers" element={<DashDrivers />} />
    <Route path="tracking" element={<DashTracking />} />
    <Route path="profile" element={<DashProfile />} />
    <Route path="*" element={<Navigate to="/404" />} />
  </Routes>
);

function DashContainer({ children }) {
  const { navWidth } = useDashLayoutCtx();
  const [openNavDrawer, setopenNavDrawer] = useState(false);

  return (
    <Container
      maxWidth={false}
      sx={{
        height: "100vh",
        padding: "0px !important",
        display: "flex",
        flexDirection: "row",
        position: "relative",
      }}
    >
      <Box
        sx={{
          padding: "5px",
          borderRadius: "0px 10px 10px 0px",
          background: COLORS.PRIMARY,
          boxShadow: "0px 10px 10px rgba(0,0,0,0.1)",
          position: "absolute",
          top: "180px",
          left: "0px",
          zIndex: 1000,
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          display: {
            xs: "flex",
            [`@media (min-width:${APP_CONSTANTS.DASH_NAV_COLLAPSE_BP})`]: {
              display: "none",
            },
          },
          cursor: "pointer",
        }}
        onClick={() => setopenNavDrawer(true)}
      >
        <Box
          sx={{
            height: "40px",
            width: "40px",
            backgroundImage: `url(${AuthentisSmLogo})`,
            backgroundSize: "contain",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
          }}
        />
      </Box>
      <Drawer
        anchor={"left"}
        open={openNavDrawer}
        onClose={() => setopenNavDrawer(false)}
      >
        <Box
          sx={{
            width: navWidth,
            height: "100%",
          }}
        >
          <DashboardNav />
        </Box>
      </Drawer>
      <Box
        sx={{
          width: navWidth,
          minWidth: navWidth,
          display: {
            xs: "none",
            [`@media (min-width:${APP_CONSTANTS.DASH_NAV_COLLAPSE_BP})`]: {
              display: "block",
            },
          },
        }}
      >
        <DashboardNav />
      </Box>
      <Box sx={{ flexGrow: 1, backgroundColor: COLORS.DASH_BG }}>
        {children}
      </Box>
    </Container>
  );
}

function Dashboard() {
  return (
    <DashLayoutCtxProvider>
      <DesktopOnlyView>
        <DashContainer>
          <Fade in timeout={500}>
            <Box
              sx={{
                width: "100%",
                height: "100%",
              }}
            >
              <DashRoutes />
            </Box>
          </Fade>
        </DashContainer>
      </DesktopOnlyView>
    </DashLayoutCtxProvider>
  );
}

export default Dashboard;
